<template>
    <div class="verify-email-card">
        <el-card shadow="always">
            <div slot="header" class="clearfix card-title">
                <span>{{ title }}</span>
            </div>
            <div class="verify-tips-wrap">
                <div class="verify-tips-title">
                    <el-icon class="el-icon-check"></el-icon>
                    <span class="verify-tips-title-text">{{ $t('Form.VerifyEmail') }}</span>
                </div>
                <div class="verify-tips-content">
                    <p>{{ verifyTipsContent }}</p>
                    <p>
                        {{ verifyTipsContentNote }} <el-button type="text primary" class="verify-btn-retry" @click="handleBackClick">{{ $t('Button.Retry') }}</el-button>
                    </p>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        title: { type: String, default: '' },
        email: { type: String, default: '' },
    },
    name: 'VerifyEmailCard',
    computed: {
        verifyTipsContent() {
            return this.language === 'zh'
                ? `请尽快到${this.email}邮箱完成验证, 验证邮件7天内有效`
                : `Please complete the verification at ${this.email} as soon as possible. The verification email will be valid within 7 days`
        },
        verifyTipsContentNote() {
            return this.$t('Form.VerifyTipsContentNote')
        },
        ...mapGetters(['language', 'size']),
    },
    methods: {
        handleBackClick() {
            this.$emit('backClick')
        },
    },
}
</script>

<style lang="scss" scoped>
.verify-email-card {
    .el-card {
        padding-bottom: 35px;
    }
    .verify-tips-wrap {
        .verify-tips-title {
            text-align: center;
            .el-icon-check {
                color: #13ec0d;
                font-size: 30px;
                font-weight: bold;
                display: inline-block;
                vertical-align: middle;
            }
            .verify-tips-title-text {
                font-size: 20px;
                font-weight: 500;
                display: inline-block;
                vertical-align: middle;
                padding-left: 20px;
            }
        }

        .verify-tips-content {
            margin-top: 20px;
            text-align: center;
            font-size: 16px;
            line-height: 16px;

            p {
                line-height: 2;
            }
            .verify-btn-retry {
                font-size: 17px;
            }
        }
    }
}
</style>
